module.exports = __webpack_public_path__ + "img/DE00067.09a21a87.png";